import CityPageTemplate from "../city-template/CityPageTemplate";
import { kalispellConfig } from "./data";

export default function KalispellPage() {
  return <CityPageTemplate config={kalispellConfig} />;
}